var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C4.2 14 3.4 13.3 3 13C1 11.6 0.4 11.1 0 10.8V15C0 15.5522 0.447812 16 1 16H9C9.55219 16 10 15.5522 10 15V10.8C9.6 11.1 9 11.6 7 13C6.6 13.3 5.8 14 5 14ZM9 8H1C0.447812 8 0 8.44781 0 9V9.5C0.8 10.1 0.7 10.1 3.6 12.2C3.9 12.4 4.5 13 5 13C5.5 13 6.1 12.4 6.4 12.3C9.3 10.2 9.2 10.2 10 9.6V9C10 8.44781 9.55219 8 9 8ZM17 5H7C6.44781 5 6 5.44781 6 6V7H9C10.0378 7 10.8934 7.79438 10.9909 8.80688L11 8.8V13H17C17.5522 13 18 12.5522 18 12V6C18 5.44781 17.5522 5 17 5ZM16 9H14V7H16V9ZM5 6C5 4.89719 5.89719 4 7 4H14V1C14 0.447812 13.5522 0 13 0H3C2.44781 0 2 0.447812 2 1V7H5V6Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/emailWhite.f429cea287293615709c7cd9a48de31d.svg";
export { ForwardRef as ReactComponent };